import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { GoogleLogo, SignOut, User as UserIcon, Sparkle } from "@phosphor-icons/react";

export default function Header() {
  const { user, login, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate("/");
  };

  return (
    <header
      data-testid="app-header"
      className="sticky top-0 z-40 backdrop-blur-xl bg-[#050505]/80 border-b border-zinc-900"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 h-16 flex items-center justify-between">
        <Link to="/" data-testid="logo-link" className="flex items-center gap-2">
          <div className="w-8 h-8 rounded-lg bg-[#CCFF00] flex items-center justify-center">
            <Sparkle weight="fill" size={18} color="#000" />
          </div>
          <span className="font-display text-xl font-semibold tracking-tight">Resize<span className="text-[#CCFF00]">Studio</span></span>
        </Link>

        <nav className="hidden md:flex items-center gap-1 text-sm">
          <Link data-testid="nav-studio" to="/studio" className="px-3 py-2 text-zinc-400 hover:text-white transition">Studio</Link>
          {user && <Link data-testid="nav-history" to="/history" className="px-3 py-2 text-zinc-400 hover:text-white transition">History</Link>}
          {user && <Link data-testid="nav-settings" to="/settings" className="px-3 py-2 text-zinc-400 hover:text-white transition">Settings</Link>}
        </nav>

        <div className="flex items-center gap-3">
          {user ? (
            <div className="flex items-center gap-3">
              <div className="hidden sm:flex items-center gap-2 chip">
                {user.picture ? (
                  <img src={user.picture} alt="" className="w-5 h-5 rounded-full" />
                ) : (
                  <UserIcon size={14} />
                )}
                <span data-testid="user-name" className="text-zinc-300">{user.name || user.email}</span>
              </div>
              <button
                data-testid="logout-button"
                onClick={handleLogout}
                className="btn-ghost"
                aria-label="Sign out"
              >
                <SignOut size={16} />
                <span className="hidden sm:inline">Sign out</span>
              </button>
            </div>
          ) : (
            <button
              data-testid="login-google-button"
              onClick={login}
              className="btn-volt"
            >
              <GoogleLogo size={16} weight="bold" />
              Sign in with Google
            </button>
          )}
        </div>
      </div>
    </header>
  );
}
